module.exports = __webpack_public_path__ + "img/fig28.d79514c5.jpg";